export var generateGuid = function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};
var phaseNameExtractor = /\[fedops] phase:([^ ]+) ([^ ]+) ?(.*) (started|finished)/;
export var getPhaseMark = function getPhaseMark(markName) {
  var matches = phaseNameExtractor.exec(markName);

  if (matches) {
    return {
      phaseName: matches[1],
      appId: matches[2],
      widgetId: matches[3]
    };
  }
};
var interactionNameExtractor = /\[fedops] ([^ ]+) interaction ([^ ]+) (started|ended)/;
export var getInteractionMark = function getInteractionMark(markName) {
  var matches = interactionNameExtractor.exec(markName);

  if (matches) {
    return {
      appName: matches[1],
      interactionName: matches[2]
    };
  }
};